export const CcmrSourceType = {
  TRACKER: 'tracker',
  FILE: 'file',
};

export default 'assessmentCheckList.utils.js';
